import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import { AdminLayout } from "@/components/layout/AdminLayout";
import { AdminLoadingState } from "@/features/admin/components/admin-loading-state";

const DashboardPage = lazy(() => import("@/pages/dashboard"));
const LoginPage = lazy(() => import("@/pages/login"));
const UsersPage = lazy(() => import("@/pages/users/index"));
const UserDetailPage = lazy(() => import("@/pages/users/detail"));
const ReportsPage = lazy(() => import("@/pages/reports/index"));
const ReportDetailPage = lazy(() => import("@/pages/reports/detail"));
const ContentPostsPage = lazy(() => import("@/pages/content/posts"));
const ContentCommentsPage = lazy(() => import("@/pages/content/comments"));
const ContentMessagesPage = lazy(() => import("@/pages/content/messages"));
const CommunitiesPage = lazy(() => import("@/pages/communities/index"));
const CommunityDetailPage = lazy(() => import("@/pages/communities/detail"));
const TaxonomySkillsPage = lazy(() => import("@/pages/taxonomy/skills"));
const TaxonomyPlatformsPage = lazy(() => import("@/pages/taxonomy/platforms"));
const MediaPage = lazy(() => import("@/pages/media"));
const AuditPage = lazy(() => import("@/pages/audit"));
const TalentReviewsPage = lazy(() => import("@/pages/talent/reviews"));
const BroadcastPage = lazy(() => import("@/pages/notifications/broadcast"));
const NotFoundPage = lazy(() => import("@/pages/not-found"));

function SuspenseRoute({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<AdminLoadingState />}>{children}</Suspense>;
}

export function AppRoutes() {
  return (
    <AdminLayout>
      <Routes>
        <Route
          path="/login"
          element={
            <SuspenseRoute>
              <LoginPage />
            </SuspenseRoute>
          }
        />
        <Route
          index
          element={
            <SuspenseRoute>
              <DashboardPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/users"
          element={
            <SuspenseRoute>
              <UsersPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/users/:id"
          element={
            <SuspenseRoute>
              <UserDetailPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <SuspenseRoute>
              <ReportsPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/reports/:id"
          element={
            <SuspenseRoute>
              <ReportDetailPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/content/posts"
          element={
            <SuspenseRoute>
              <ContentPostsPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/content/comments"
          element={
            <SuspenseRoute>
              <ContentCommentsPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/content/messages"
          element={
            <SuspenseRoute>
              <ContentMessagesPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/communities"
          element={
            <SuspenseRoute>
              <CommunitiesPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/communities/:id"
          element={
            <SuspenseRoute>
              <CommunityDetailPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/taxonomy/skills"
          element={
            <SuspenseRoute>
              <TaxonomySkillsPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/taxonomy/platforms"
          element={
            <SuspenseRoute>
              <TaxonomyPlatformsPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/media"
          element={
            <SuspenseRoute>
              <MediaPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/audit"
          element={
            <SuspenseRoute>
              <AuditPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/talent/reviews"
          element={
            <SuspenseRoute>
              <TalentReviewsPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="/notifications/broadcast"
          element={
            <SuspenseRoute>
              <BroadcastPage />
            </SuspenseRoute>
          }
        />
        <Route
          path="*"
          element={
            <SuspenseRoute>
              <NotFoundPage />
            </SuspenseRoute>
          }
        />
      </Routes>
    </AdminLayout>
  );
}
